export class InsolesUserSummaryModel {
    username: string;
    name: string;
}
